import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  exerciseCategoryList,
  fetchAssessExercises,
} from "../../Redux/Actions";
import { userQuickTrainWorkout, userWorkoutAction } from "../../Redux/Actions/UserReportActions";
import { types } from "../../Redux/Actions/types";
import { Constants } from "../Common/Constants";
import ReactSelect from "../Common/Fields/ReactSelect";
import TabsBootstrap from "../Common/UiModel/TabsBootstrap";
import Monthly from "./Monthly";
import Quarterly from "./Quarterly";
import Weekly from "./Weekly";
import Yearly from "./Yearly";

const Analytics = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { exerciseCategorylist } = useSelector(
    (state) => state.ExerciseCategory
  );
  const [bodyPart, setBodyPart] = useState([]);
  const [bodyPartData, setBodyPartData] = useState([]);
  // const [assessmentExer, setAssessmentExer] = useState(
  //   Constants.statusOptions?.[0]
  // );
  // const [assessmentExerData, setAssessmentExerData] = useState([]);

  const tabsList = [
    {
      eventKey: Constants.analyticsWeek,
      title: Constants.analyticsSevenDays,
      component: <Weekly />,
    },
    {
      eventKey: Constants.analyticsMonth,
      title: Constants.analyticsThirtyDays,
      component: <Monthly />,
    },
    {
      eventKey: Constants.analyticsThreeMonths,
      title: Constants.analyticsNinetyDays,
      component: <Quarterly />,
    },
    {
      eventKey: Constants.analyticsYear,
      title: Constants.analyticsOneYear,
      component: <Yearly />,
    },
  ];

  const [activetab, setActiveTab] = useState(tabsList?.[0]?.eventKey);

  useEffect(() => {
    dispatch(
      exerciseCategoryList({
        skipPagination: true,
        status: Constants.status.ACTIVE,
      })
    );
    getAssessExer();
  }, []);

  const getAssessExer = async () => {
    const resp = await dispatch(fetchAssessExercises());
    if (resp?.data?.length > 0) {
      const data = [Constants.statusOptions?.[0]];
      resp?.data?.forEach((exer) => {
        data.push({
          value: exer?._id,
          label: exer?.exerciseName,
        });
      });
      // setAssessmentExerData(data);
    }
  };


  const callMultipleAPIs = (data2, data3) => async (dispatch) => {
    const query2 = new URLSearchParams(data2).toString();
    const query3 = new URLSearchParams(data3).toString();

    const apis = [
      { url: `${process.env.REACT_APP_API_URL}reports/totalWorkoutsReport?${query2}`, key: "totalWorkoutsReport", action: userWorkoutAction },
      { url: `${process.env.REACT_APP_API_URL}reports/totalWorkoutsReport?${query3}`, key: "totalWorkoutsReport", action: userQuickTrainWorkout },
      // { url: `${process.env.REACT_APP_API_URL}/reports/totalWeightsLiftedReport?${query}`, },
      // { url: `${process.env.REACT_APP_API_URL}reports/strengthAssesmentReport?${query}`, key: "strengthAssesmentReport", action: userStrengthAssessmentAction },
      // { url: `${process.env.REACT_APP_API_URL}reports/userGoalCountReport?${query}`, key: "userGoalCountReport", action: userGoalCountAction },
      // { url: `${process.env.REACT_APP_API_URL}reports/userWorkoutCompletedRecordsReport?${query}`, key: "userWorkoutCompletedRecordsReport", action: userWorkoutCompletedAction },
      // { url: `${process.env.REACT_APP_API_URL}reports/exerciseWiseStrengthAssessmentReport?${query}`, key: "exerciseWiseStrengthAssessmentReport", action: userExerciseWiseStrengthAssAction },
      // { url: `${process.env.REACT_APP_API_URL}reports/total-workouts-report-by-hours?${query}`, key: "totalWorkoutReportByHours", action: userTotalWorkoutsByHour },

    ];
    const safeFetch = (url) =>
      fetch(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            Constants.accessToken
          )}`,
        },
      }).then((res) => {
        if (!res.ok) {
          return Promise.reject(new Error(`HTTP ${res.status}`));
        }
        return res.json();
      });
    dispatch({ type: types.LOADER_VISIBLE });
    const results = await Promise.allSettled(
      apis.map((api) => safeFetch(api.url))
    );

    results.forEach((result, index) => {
      const { action } = apis[index];
      if (result.status === "fulfilled") {
        // 👈 update slice
        dispatch(action(result.value));
      } else {
        dispatch({
          type: types.ERROR_ALERT_VISIBLE,
          payload: {
            message: "Error fetching data",
          },
        });
      }
    });
    dispatch({ type: types.LOADER_HIDE });
  };


  useEffect(() => {
    const data = {
      id,
      days: activetab,
      bodyPart: bodyPart?.value || null,
      // assessExer: assessmentExer?.value || null,
    };

    // const today = new Date();
    // const formatted = today.toISOString().split("T")[0];


    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const formatted = tomorrow.toISOString().split("T")[0];

    //   const data2 = {
    //   userId: data.id,
    //   noOfDays: data.days,
    //   currentDate: formatted,
    //   ...(data.assessExer && { exerciseId: data.assessExer }),
    //   ...(data.bodyPart && { exerciseCategoryId: data.bodyPart }),
    // };


    const data2 = {
      userId: data.id,
      noOfDays: data.days,
      currentDate: formatted,
      // ...(data.assessExer && data.assessExer !== "All" && { exerciseId: data.assessExer }),
      ...(data.bodyPart && data.bodyPart !== "All" && { exerciseCategoryId: data.bodyPart }),
    };

    const data3 = {
      userId: data.id,
      noOfDays: data.days,
      currentDate: formatted,
      // ...(data.assessExer && data.assessExer !== "All" && { exerciseId: data.assessExer }),
      // ...(data.bodyPart && data.bodyPart !== "All" && { exerciseCategoryId: data.bodyPart }),
    };

    // dispatch(getUserDetail(data));
    dispatch(callMultipleAPIs(data2, data3));
  }, [activetab, bodyPart?.value]);


  useEffect(() => {
    if (exerciseCategorylist?.exerciseCategory?.length > 0) {
      const data = exerciseCategorylist?.exerciseCategory?.map((item) => ({
        value: item?._id,
        label: item?.title,
      }));
      // adding All option to the to the body part category drop down
      const data2 = [...data, { value: "All", label: "All" }];
      setBodyPartData(data2);
      const lenData2 = data2?.length;
      // setBodyPart(data2?.[6]);
      setBodyPart(data2?.[lenData2 - 1]);
    }
  }, [exerciseCategorylist]);

  useEffect(() => {
    // Set active tab as per URL
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get(Constants.activeTab);
    if (tabParam && tabsList.map((elt) => elt.eventKey).includes(tabParam)) {
      setActiveTab(tabParam);
    }
  }, [location]);

  const handleTabSelect = (key) => {
    // Set URL in correspondance with active tab
    setActiveTab(key);
    const queryParams = new URLSearchParams(location.search);
    queryParams.set(Constants.activeTab, key);
    navigate(`?${queryParams.toString()}`);
  };

  const onBodyPartChnage = (e) => {
    setBodyPart(e);
  };

  return (
    <div className="row catalog_box al_catalog_box mt-4">
      <div className="col-md-12 mb-4 order-list-view">
        {/* <div className="col-md-3 filter-tabs mx-2">
          <ReactSelect
            label={`${Constants.strengthAssessment}`}
            options={assessmentExerData}
            onChange={(e) => setAssessmentExer(e)}
            value={assessmentExer}
          />
        </div> */}
        <div className="col-md-3 filter-tabs">
          <ReactSelect
            label={`${Constants.exerciseCategory}`}
            options={bodyPartData}
            onChange={(e) => onBodyPartChnage(e)}
            value={bodyPart}
          />
        </div>
        {tabsList.length > 0 && (
          <TabsBootstrap
            defaultActiveKey={activetab}
            onSelect={(index) => {
              setActiveTab(index);
            }}
            activeKey={activetab}
            handleTabSelect={handleTabSelect}
            options={tabsList}
          />
        )}
      </div>
    </div>
  );
};

export default Analytics;
